import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {
  AdministratorSection,
  BillingIntervalSection,
  CreateBreadcrumbs,
  CreateFooter,
  IdentitySection,
  LicenseConfigurationSection,
} from './components';
import { useCreateOrganization } from './hooks';

export const CreateOrganization: React.FC = () => {
  const page = useCreateOrganization();

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <CreateBreadcrumbs onBack={page.handleCancel} />

        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em', mb: 0.5 }}>
            Create Organization
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Register a new client entity and set up their administrative account.
          </Typography>
        </Box>

        <Paper
          variant="outlined"
          sx={{
            borderRadius: 6,
            overflow: 'hidden',
            boxShadow: 2,
          }}
        >
          <Stack spacing={6} sx={{ p: { xs: 3, md: 5 } }}>
            <IdentitySection
              organizationName={page.formData.organization_name}
              companySize={page.formData.company_size}
              domains={page.formData.organization_domains.join(', ')}
              onOrganizationNameChange={(value) => page.handleFieldChange('organization_name', value)}
              onCompanySizeChange={(value) => page.handleFieldChange('company_size', value)}
              onDomainsChange={page.handleDomainsChange}
            />
            <AdministratorSection
              firstName={page.formData.first_name}
              lastName={page.formData.last_name}
              email={page.formData.email}
              onFirstNameChange={(value) => page.handleFieldChange('first_name', value)}
              onLastNameChange={(value) => page.handleFieldChange('last_name', value)}
              onEmailChange={(value) => page.handleFieldChange('email', value)}
            />
            <BillingIntervalSection
              billingInterval={page.billingInterval}
              onBillingIntervalChange={page.handleBillingIntervalChange}
            />
            <LicenseConfigurationSection
              catalog={page.catalog}
              isLicenseActive={page.isLicenseActive}
              onToggleLicense={page.toggleLicense}
              startDate={page.licenseStartDate}
              endDate={page.licenseEndDate}
              onStartDateChange={(key, value) => page.updateLicenseDate(key, 'startDate', value)}
              onEndDateChange={(key, value) => page.updateLicenseDate(key, 'endDate', value)}
              monthlyCredits={page.monthlyCreditsValue}
              onMonthlyCreditsChange={page.updateMonthlyCredits}
            />
          </Stack>

          <CreateFooter
            isCreateDisabled={page.isCreateDisabled}
            disabledTooltip={page.disabledTooltip}
            onCancel={page.handleCancel}
            onCreate={() => void page.handleCreateOrganization()}
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default CreateOrganization;
